<template>
  <div>
    <right-panel class="float-right" :id="id" width="400px" @hidden="rightPanelClosed">
      <content-loading v-if="!atLeastShow" />

      <div v-if="atLeastShow" class="pl-5 pr-5 position-relative pb-5">
        <!---->
        <h5>
          {{ $t("inventory.filter.plural") }}
        </h5>

        <h6 class="mb-0 mt-2 text-muted">{{ $t("department.text") }}</h6>
        <filter-select
          id="departmentFilter"
          ref="departmentFilter"
          :selected="criteria.department"
          @filter="onDepartmentSearch"
          @changed="onDepartmentSelect"
          :placeholder="$t('common.choose')"
        />

        <div v-if="criteria.department">
          <h6 class="mb-0 mt-2 text-muted">{{ $t("process.text") }}</h6>
          <filter-select
            id="processFilter"
            ref="processFilter"
            :selected="criteria.process"
            @filter="onProcessSearch"
            @changed="onProcessSelect"
            :placeholder="$t('common.choose')"
          />
        </div>

        <div v-if="criteria.process">
          <h6 class="mb-0 mt-2 text-muted">{{ $t("datasource.text") }}</h6>
          <filter-select
            id="datasourceFilter"
            ref="datasourceFilter"
            :selected="criteria.datasource"
            @filter="onDatasourceSearch"
            @changed="onDatasourceSelect"
            :placeholder="$t('common.choose')"
          />
        </div>

        <div v-if="criteria.datasource">
          <h6 class="mb-0 mt-2 text-muted">{{ $t("data-category.text") }}</h6>
          <filter-select
            id="dataCategoryFilter"
            ref="dataCategoryFilter"
            :selected="criteria.dataCategory"
            @filter="onDataCategorySearch"
            @changed="onDataCategorySelect"
            :placeholder="$t('common.choose')"
          />
        </div>
        <div v-if="criteria.dataCategory">
          <h6 class="mb-0 mt-2 text-muted">{{ $t("data.text") }}</h6>
          <filter-select id="dataFilter" ref="dataFilter" :selected="criteria.data" @filter="onDataSearch" @changed="onDataSelect" :placeholder="$t('common.choose')" />
        </div>

        <div v-if="criteria.data">
          <h6 class="mb-0 mt-2 text-muted">{{ $t("datasubject.text") }}</h6>
          <filter-select
            id="datasubjectFilter"
            ref="datasubjectFilter"
            :selected="criteria.datasubject"
            @filter="onDatasubjectSearch"
            @changed="onDatasubjectSelect"
            :placeholder="$t('common.choose')"
          />
        </div>

        <h6 class="mb-0 mt-2 text-muted">{{ $t("minimization.collect.select") }}</h6>
        <select class="form-control" v-model="miminizationStatus">
          <option :value="null">{{ $t("common.all") }}</option>
          <option value="MINIMIZED">{{ $t("minimization.status.minimized") }}</option>
          <option value="NOT_MINIMIZED">{{ $t("minimization.status.not-minimized") }}</option>
        </select>

        <div style="display: flex; gap: 1rem; position: fixed; top: 0.2rem; right: 3rem;">
          <sweet-button @click="apply()" variant="success" icon="bx bx-check" size="sm" buttonClass="mt-2">
            {{ $t("inventory.filter.apply") }}
          </sweet-button>

          <sweet-button @click="clear()" variant="secondary" icon="bx bx-x" size="sm" buttonClass="mt-2 float-right">
            {{ $t("common.clear") }}
          </sweet-button>
        </div>

        <!---->
      </div>
    </right-panel>
    <!---->
    <sweet-button @click="toggleSidebar()" variant="info" icon="mdi mdi-filter" size="sm" buttonClass="mr-2">
      {{ $t("inventory.filter.text") }}
    </sweet-button>
    <sweet-button v-if="hasFilter" @click="clear()" variant="light" icon="bx bx-x" size="sm" buttonClass="mr-2">
      {{ $t("inventory.filter.clear") }}
    </sweet-button>
    <div v-if="hasFilter">
      <b-breadcrumb v-if="breadcrumb.length > 0" class="mt-3" :items="breadcrumb" />
      <b-alert v-if="criteria.minimizationStatus == 'MINIMIZED'" show variant="primary" class="mt-2"> <span v-html="$t('minimization.filter-status.minimized')"> </span></b-alert>
      <b-alert v-else-if="criteria.minimizationStatus == 'NOT_MINIMIZED'" show variant="primary" class="mt-2">
        <span v-html="$t('minimization.filter-status.not-minimized')"></span>
      </b-alert>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  computed: {
    criteria() {
      return this.$store.getters["collectMinimizationFilter/criteria"];
    },
    hasFilter() {
      return Object.keys(this.criteria).find((i) => !!this.criteria[i]);
    },
    miminizationStatus: {
      get() {
        return this.criteria.minimizationStatus;
      },
      set(status) {
        this.$store.commit("collectMinimizationFilter/minimizationStatus", status);
      },
    },
    breadcrumb() {
      return Object.keys(this.criteria)
        .filter((key) => key != "minimizationStatus" && !!this.criteria[key])
        .map((key) => this.criteria[key].name[this.currentLanguage]);
    },
  },

  data() {
    return { atLeastShow: false };
  },

  methods: {
    async onDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(item) {
      this.$store.commit("collectMinimizationFilter/department", item);
      this.$refs.processFilter?.reset();
    },

    //Process
    async onProcessSearch(value, callback) {
      if (!this.criteria.department) {
        const response = await this.$store.dispatch(`organizationProcess/paginate`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });

        callback(response.data?.docs ?? []);
      } else {
        const response = await this.$store.dispatch(`organizationDepartmentProcess/paginate`, {
          options: { limit: 1000 },
          query: { name: { value }, department: { value: { _id: this.criteria.department._id }, isObject: true } },
        });

        callback(response.data?.docs ?? []);
      }
    },
    onProcessSelect(item) {
      this.$store.commit("collectMinimizationFilter/process", item);
      this.$refs.datasourceFilter?.reset();
    },

    //Datasource
    async onDatasourceSearch(value, callback) {
      if (!this.criteria.department) {
        const response = await this.$store.dispatch(`organizationDatasource/paginate`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });

        callback(response.data?.docs ?? []);
      } else if (this.criteria.process) {
        const response = await this.$store.dispatch(`organizationProcessDatasource/paginate`, {
          options: { limit: 1000 },
          query: { name: { value }, process: { value: { _id: this.criteria.process._id }, isObject: true } },
        });

        callback(response.data?.docs ?? []);
      }
    },
    onDatasourceSelect(item) {
      this.$store.commit("collectMinimizationFilter/datasource", item);
      this.$refs.dataCategoryFilter?.reset();
    },

    //Datacategory
    async onDataCategorySearch(value, callback) {
      if (this.criteria.department && this.criteria.process && this.criteria.datasource) {
        const response = await this.$store.dispatch("organizationProcessDatasource/paginateDatasourceOwnedDataCategories", {
          pagination: { options: { limit: 1000 } },
          processDatasourceId: this.criteria.datasource._id,
        });

        callback(response.data?.docs ?? []);
      } else {
        const response = await this.$store.dispatch(`organizationDataCategory/paginate`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });
        callback(response.data?.docs ?? []);
      }
    },
    onDataCategorySelect(item) {
      this.$store.commit("collectMinimizationFilter/dataCategory", item);
      this.$refs.dataFilter?.reset();
    },

    //Data
    async onDataSearch(value, callback) {
      if (!this.criteria.department) {
        const response = await this.$store.dispatch(`organizationData/paginate`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });

        callback(response.data?.docs ?? []);
      } else if (this.criteria.datasource) {
        const query = {
          name: { value },
          datasource: {
            value: { _id: this.criteria.datasource._id },
            isObject: true,
          },
        };

        if (this.criteria.dataCategory) {
          query.category = { value: { _id: this.criteria.dataCategory._id }, isObject: true };
        }
        const response = await this.$store.dispatch(`organizationDatasourceData/paginate`, {
          options: { limit: 1000 },
          query,
        });

        callback(response.data?.docs ?? []);
      }
    },
    onDataSelect(item) {
      this.$store.commit("collectMinimizationFilter/data", item);
      this.$refs.datasubjectFilter?.reset();
    },

    //Datasubject
    async onDatasubjectSearch(value, callback) {
      if (this.criteria.department && this.criteria.process && this.criteria.datasource && this.criteria.data) {
        const response = await this.$store.dispatch(`organizationDataDatasubject/paginate`, {
          options: { limit: 1000 },
          query: { name: { value }, data: { value: { _id: this.criteria.data._id }, isObject: true } },
        });

        callback(response.data?.docs ?? []);
      }
      {
        const response = await this.$store.dispatch(`organizationDatasubject/paginate`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });
        callback(response.data?.docs ?? []);
      }
    },
    onDatasubjectSelect(item) {
      this.$store.commit("collectMinimizationFilter/datasubject", item);
    },

    //
    apply() {
      this.$emit("apply");
      this.toggleSidebar();
    },
    clear() {
      this.$store.commit("collectMinimizationFilter/clear");
      if (this.atLeastShow) {
        this.$refs.departmentFilter.reset();
        this.$refs.processFilter?.reset();
        this.$refs.datasourceFilter?.reset();
        this.$refs.dataCategoryFilter?.reset();
        this.$refs.dataFilter?.reset();
        this.$refs.datasubjectFilter?.reset();
      }

      this.$emit("apply");
    },

    toggleSidebar() {
      this.$root.$emit("bv::toggle::collapse", this.id);
      setTimeout(() => (this.atLeastShow = true), 100);
    },
    rightPanelClosed() {},
  },
};
</script>
